import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { staggerContainer, fadeUp } from '../utils/animations';
const benefits = ['Comprender mejor tus emociones', 'Tener herramientas para gestionar pensamientos negativos', 'Crear hábitos que mejoren tu bienestar', 'Recuperar motivación y claridad mental', 'Sentir que vuelves a tener control sobre tu vida'];
export function BenefitsSection() {
  return <section className="py-28 md:py-32 px-4 relative overflow-hidden" data-id="element-33">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/uB9ZY93CBEJB5usPDQ2AUv/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-35" />
        <div className="absolute inset-0 bg-white/80" data-id="element-36"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-38">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-4" data-id="element-39">
            Beneficios
          </h2>
          <p className="text-xl text-[#F4A261] font-serif italic" data-id="element-40">
            Después de leer esta guía podrás:
          </p>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-41">
          {benefits.map((benefit, index) => <motion.div key={index} variants={fadeUp} className="flex items-center p-6 bg-[#F7F3E9] rounded-3xl border border-[#E8E1D5] shadow-[0_4px_20px_rgba(47,58,61,0.02)]" data-id="element-42">
              <div className="flex-shrink-0" data-id="element-43">
                <div className="w-12 h-12 rounded-2xl bg-[#F4A261]/15 flex items-center justify-center" data-id="element-44">
                  <CheckIcon className="w-6 h-6 text-[#F4A261]" data-id="element-45" />
                </div>
              </div>
              <p className="ml-4 text-lg text-[#2F3A3D] font-medium leading-snug" data-id="element-46">
                {benefit}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}